let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dpvpW")).then(() => parcelRequire('gGqmR'));